import i18n from 'config/i18n';
import { isNil } from 'ramda';
import * as yup from 'yup';

import { getLocale } from 'utils/date';
import { convertToNullWhenNaN } from 'utils/validation';

const t = i18n.getFixedT(getLocale());

const postalCodeSchema = yup
  .string()
  .matches(/^\d{4}\s?[a-zA-Z]{2}$/, t('validationPostalCode'))
  .transform((value) => value.replace(/\s/g, ''));

export const schema = yup.object().shape(
  {
    fromCountryCode: yup
      .object()
      .shape({
        value: yup.string().required(
          t('validationFieldRequired', {
            name: t('distances.grid.fromCountryCode')
          })
        )
      })
      .required(
        t('validationFieldRequired', {
          name: t('distances.grid.fromCountryCode')
        })
      )
      .typeError(
        t('validationFieldRequired', {
          name: t('distances.grid.fromCountryCode')
        })
      ),
    fromPostalcode: postalCodeSchema.required(
      t('validationFieldRequired', { name: t('distances.grid.fromPostalcode') })
    ),
    toCountryCode: yup
      .object()
      .shape({
        value: yup.string().required(
          t('validationFieldRequired', {
            name: t('distances.grid.toCountryCode')
          })
        )
      })
      .required(
        t('validationFieldRequired', {
          name: t('distances.grid.toCountryCode')
        })
      )
      .typeError(
        t('validationFieldRequired', {
          name: t('distances.grid.toCountryCode')
        })
      ),
    toPostalcode: postalCodeSchema.required(
      t('validationFieldRequired', { name: t('distances.grid.toPostalcode') })
    ),
    distanceShortest: yup
      .number()
      .nullable()
      .transform(convertToNullWhenNaN)
      .min(0, t('validation.greaterThan', { field: 0 }))
      .when('distanceFastest', {
        is: (distanceFastest) => isNil(distanceFastest),
        then: yup
          .number()
          .nullable()
          .transform(convertToNullWhenNaN)
          .required(t('distances.error.distanceRequired'))
      }),
    traveltimeShortest: yup
      .number()
      .nullable()
      .transform(convertToNullWhenNaN)
      .min(0, t('validation.greaterThan', { field: 0 })),
    distanceFastest: yup
      .number()
      .nullable()
      .transform(convertToNullWhenNaN)
      .min(0, t('validation.greaterThan', { field: 0 }))
      .when('distanceShortest', {
        is: (distanceShortest) => isNil(distanceShortest),
        then: yup
          .number()
          .nullable()
          .transform(convertToNullWhenNaN)
          .required(t('distances.error.distanceRequired'))
      }),
    traveltimeFastest: yup
      .number()
      .nullable()
      .transform(convertToNullWhenNaN)
      .min(0, t('validation.greaterThan', { field: 0 }))
  },
  [['distanceShortest', 'distanceFastest']]
);
